import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Modal, Button } from '@mui/material';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';

const TimeTamplates = () => {
  const dispatch = useDispatch();
  const { timeTemplates } = useSelector((state) => state.general);
  const [selectedTimeTemplate, setSelectedTimeTemplate] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'timeTemplates',
        route: 'timeTemplates/getTimeTemplates',
      }),
    );
  }, [dispatch]);

  console.log({ timeTemplates });

  const handleOpen = (condition) => {
    setSelectedTimeTemplate(condition);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedTimeTemplate(null);
  };

  const handleDuplicate = (template) => {
    const { _id } = template;
    dispatch(
      apiAction({
        reduxField: 'timeTemplates',
        route: 'timeTemplates/duplicateTimeTemplate',
        id: _id,
        timeTemplates,
      }),
    );
    // dispatch(
    //   generalSet({
    //     reduxField: 'timeTemplates',
    //     value: [...timeTemplates, { ...template, _id: 'temp-id-' + Date.now(), name: template.name + ' (Copy)' }],
    //   }),
    // );
  };

  const handleDelete = () => {
    dispatch(
      apiAction({
        reduxField: 'deletedTimeTemplate',
        route: 'timeTemplates/deleteTimeTemplate',
        id: selectedTimeTemplate._id,
      }),
    );
    dispatch(
      generalSet({
        reduxField: 'timeTemplates',
        value: timeTemplates.filter((c) => c._id !== selectedTimeTemplate._id),
      }),
    );
    handleClose();
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 250,
      renderCell: (params) => <Link to={`/timeTemplate/${params.row._id}`}>{params.value}</Link>,
    },
    {
      field: 'Timestamps',
      headerName: 'Timestamps',
      width: 150,
      renderCell: (params) => <span>{Array.isArray(params.row.template) ? params.row.template.length : ''}</span>,
    },
    {
      field: 'timezone',
      headerName: 'Timezone',
      width: 100,
    },
    {
      field: 'actions',
      headerName: '',
      width: 500,
      renderCell: (params) => (
        <>
          <Link className='btn btn-sm btn-outline-primary' to={`/timeTemplate/${params.row._id}`}>
            View
          </Link>

          <button className='btn btn-sm btn-outline-danger ml-2' onClick={() => handleOpen(params.row)}>
            <i className='fa fa-trash' aria-hidden='true'></i>
          </button>
          <button className='btn btn-sm btn-outline-secondary ml-2' onClick={() => handleDuplicate(params.row)}>
            Duplicate
          </button>
        </>
      ),
    },
  ];

  return Array.isArray(timeTemplates) ? (
    <div className='container mb-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center border-bottom mt-4'>
        <h1>Time Templates</h1>
      </div>
      <div className='row d-flex justify-content-center m-4'>
        <Link to='/createTimeTemplate' className='btn btn-outline-dark'>
          Create a Time Template
        </Link>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <Box style={{ height: 600, width: '100%' }}>
          <DataGrid
            rows={timeTemplates.map((con) => {
              return { id: con._id, ...con };
            })}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            //   checkboxSelection
            disableSelectionOnClick
          />
        </Box>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div
          className='modal-content'
          style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', outline: 'none', margin: '25%' }}
        >
          <h4>Confirm Deletion</h4>
          <p>Are you sure you want to delete this time template?</p>
          <Button variant='contained' color='secondary' onClick={handleDelete}>
            Delete
          </Button>
          <Button variant='contained' onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </Modal>
    </div>
  ) : (
    <Spinner />
  );
};

export default TimeTamplates;
